import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Input,
  Textarea,
  Stack,
  Heading,
  SimpleGrid,
  Checkbox,
  Image,
  Switch,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import axios from "../../../axios";


const CreateCourse = () => {
  const [courses, setCourses] = useState([]);
  const [inactiveCourses, setInactiveCourses] = useState([]);
  const [selectedSubCourses, setSelectedSubCourses] = useState([]);
const [subjectInput, setSubjectInput] = useState("");
  const [form, setForm] = useState({
    planName: "",
    planNameHin: "",
    desc: "",
    descHin: "",
    planImage: "",
    price: "",
    offerPrice: "",
    planValidityDays: "",
    totalQuestions: "",
    subject:[],
    exams: [],
    subCourses: [],
    isActive: true, // ✅ ADD THIS

    targetAudience: "",
    targetAudienceHin: "",

    bonus: {
      dailyLogin: false,
      streakRewards: false,
    },

    scoreRules: {
      correct: "",
      wrong: "",
      skipped: "",
      timeUp: "",
      rightLimit: "",
      wrongLimit: "",
      skipLimit: "",
      timeUpLimit: "",
    },

    rewardRules: {
      coinToCashRatio: "",
      gstPercent: "",
      minWithdrawAmount: "",
      withdrawAfterDays: "",
    },
  });
const initialFormState = {
  planName: "",
  planNameHin: "",
  desc: "",
  descHin: "",
  planImage: "",
  price: "",
  offerPrice: "",
  planValidityDays: "",
  totalQuestions: "",

  exams: [],
  subCourses: [],
   isActive: true, // ✅ ADD THIS
  targetAudience: "",
  targetAudienceHin: "",
  subject: [],

  bonus: {
    dailyLogin: false,
    streakRewards: false,
  },

  scoreRules: {
    correct: "",
    wrong: "",
    skipped: "",
    timeUp: "",
    rightLimit: "",
    wrongLimit: "",
    skipLimit: "",
    timeUpLimit: "",
  },

  rewardRules: {
    coinToCashRatio: "",
    gstPercent: "",
    minWithdrawAmount: "",
    withdrawAfterDays: "",
  },
};

  // 🔹 Fetch all plans
  // const getAllCourses = async () => {
  //   const res = await axios.get("/getAllCoursesForAdmin");
  //   console.log(res.data,"all courses")
  //   setCourses(res.data.result);
  // };

  // useEffect(() => {
  //   getAllCourses();
  // }, []);

  // 🔹 Input Handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
  const getInActiveCourses = async () => {
    const res = await axios.get("/getAllInActiveCourses");
    console.log(res.data, "inactive course");

    setInactiveCourses(res.data.result);
  };

  useEffect(() => {
    // getAllCourses();
    getInActiveCourses();
  }, []);

  const addSubject = () => {
  if (!subjectInput.trim()) return;

  setForm((prev) => ({
    ...prev,
    subject: [...prev.subject, subjectInput.trim()],
  }));

  setSubjectInput("");
};

const removeSubject = (index) => {
  setForm((prev) => ({
    ...prev,
    subject: prev.subject.filter((_, i) => i !== index),
  }));
};

  // 🔹 Nested Handler
  const handleNestedChange = (section, key, value) => {
    setForm({
      ...form,
      [section]: { ...form[section], [key]: value },
    });
  };

  // 🔹 Add Exam
  const addExam = () => {
    setForm({
      ...form,
      exams: [...form.exams, { examName: "", examNameHin: "" }],
    });
  };

  // 🔹 Add Sub Course
  // const addSubCourse = () => {
  //   setForm({
  //     ...form,
  //     subCourses: [
  //       ...form.subCourses,
  //       { title: "", titleHin: "", totalQuestions: "" },
  //     ],
  //   });
  // };

  const handleSubCourseSelect = (id) => {
    setSelectedSubCourses((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  // 🔹 Submit
  const handleSubmit = async () => {
    const payload = {
      ...form,
      scoreRules: Object.fromEntries(
        Object.entries(form.scoreRules).map(([k, v]) => [k, Number(v)]),
      ),
      rewardRules: Object.fromEntries(
        Object.entries(form.rewardRules).map(([k, v]) => [k, Number(v)]),
      ),
      subCourses: selectedSubCourses,
    };

    await axios.post("/addCourse", payload);

    alert("Plan Created");
     // 🔹 FORM RESET
    setForm(initialFormState);
    setSelectedSubCourses([]);
    // getAllCourses();
  };

  return (
    <Box p={6}>
      <Heading mb={4}>Create Learn2Earn Plan</Heading>

      <SimpleGrid columns={2} spacing={4}>
        <Input
          name="planName"
          placeholder="Plan Name"
          value={form.planName}
          onChange={handleChange}
        />
        <Input
          name="planNameHin"
          placeholder="Plan Name (Hindi)"
          value={form.planNameHin}
          onChange={handleChange}
        />

        <Textarea
          name="desc"
          placeholder="Description"
          value={form.desc}
          onChange={handleChange}
        />
        <Textarea
          name="descHin"
          placeholder="Description (Hindi)"
          value={form.descHin}
          onChange={handleChange}
        />

        <Input
          name="planImage"
          placeholder="Plan Image URL"
          value={form.planImage}
          onChange={handleChange}
        />

        <Input name="price" placeholder="Price" value={form.price} onChange={handleChange} />
        <Input
          name="offerPrice"
          placeholder="Offer Price"
          value={form.offerPrice}
          onChange={handleChange}
        />
        <Input
          name="totalQuestions"
          type="number"
          placeholder="Total Questions"
          value={form.totalQuestions}
          onChange={handleChange}
        />

        <Input
          name="planValidityDays"
          type="number"
          placeholder="Plan Validity (Days)"
          value={form.planValidityDays}
          onChange={handleChange}
        />

        <Input
          name="targetAudience"
          placeholder="Target Audience"
          value={form.targetAudience}
          onChange={handleChange}
        />
        <Input
          name="targetAudienceHin"
          placeholder="Target Audience (Hindi)"
          value={form.targetAudienceHin}
          onChange={handleChange}
        />
        <Input
          name="rightText"
          placeholder="Right Text"
          value={form.rightText}
          onChange={handleChange}
        />
        <Input
          name="wrongText"
          placeholder="Wrong Text"
          value={form.wrongText}
          onChange={handleChange}
        />
      </SimpleGrid>
       <FormControl display="flex" alignItems="center" mt={4}>
  <FormLabel mb="0">
    Plan Active
  </FormLabel>
  <Switch
    isChecked={form.isActive}
    colorScheme="green"
    onChange={(e) =>
      setForm({ ...form, isActive: e.target.checked })
    }
  />
</FormControl>

      {/* Bonus */}
      <Stack mt={4}>
        <Checkbox
          onChange={(e) =>
            handleNestedChange("bonus", "dailyLogin", e.target.checked)
          }
        >
          Daily Login Bonus
        </Checkbox>
        <Checkbox
          onChange={(e) =>
            handleNestedChange("bonus", "streakRewards", e.target.checked)
          }
        >
          Streak Rewards
        </Checkbox>
      </Stack>
      {/* Score Rules */}
      <Heading size="md" mt={6}>
        Score Rules
      </Heading>

      <SimpleGrid columns={2} spacing={4} mt={2}>
        <Input
          placeholder="Correct Answer Score"
          
          onChange={(e) =>
            handleNestedChange("scoreRules", "correct", e.target.value)
          }
        />
        <Input
          placeholder="Wrong Answer Score"
          onChange={(e) =>
            handleNestedChange("scoreRules", "wrong", e.target.value)
          }
        />
        <Input
          placeholder="Skipped Score"
          onChange={(e) =>
            handleNestedChange("scoreRules", "skipped", e.target.value)
          }
        />
        <Input
          placeholder="Time Up Score"
          onChange={(e) =>
            handleNestedChange("scoreRules", "timeUp", e.target.value)
          }
        />

        <Input
          placeholder="Right Limit"
          onChange={(e) =>
            handleNestedChange("scoreRules", "rightLimit", e.target.value)
          }
        />
        <Input
          placeholder="Wrong Limit"
          onChange={(e) =>
            handleNestedChange("scoreRules", "wrongLimit", e.target.value)
          }
        />
        <Input
          placeholder="Skip Limit"
          onChange={(e) =>
            handleNestedChange("scoreRules", "skipLimit", e.target.value)
          }
        />
        <Input
          placeholder="Time Up Limit"
          onChange={(e) =>
            handleNestedChange("scoreRules", "timeUpLimit", e.target.value)
          }
        />
      </SimpleGrid>
      {/* Reward Rules */}
      <Heading size="md" mt={6}>
        Reward Rules
      </Heading>

      <SimpleGrid columns={2} spacing={4} mt={2}>
        <Input
          placeholder="Coin to Cash Ratio"
          onChange={(e) =>
            handleNestedChange("rewardRules", "coinToCashRatio", e.target.value)
          }
        />
        <Input
          placeholder="GST Percent"
          onChange={(e) =>
            handleNestedChange("rewardRules", "gstPercent", e.target.value)
          }
        />
        <Input
          placeholder="Minimum Withdraw Amount"
          onChange={(e) =>
            handleNestedChange(
              "rewardRules",
              "minWithdrawAmount",
              e.target.value,
            )
          }
        />
        <Input
          placeholder="Withdraw After Days"
          onChange={(e) =>
            handleNestedChange(
              "rewardRules",
              "withdrawAfterDays",
              e.target.value,
            )
          }
        />
      </SimpleGrid>

      {/* Exams */}
      <Heading size="md" mt={6}>
        Exams
      </Heading>
      <Button size="sm" onClick={addExam} mb={2}>
        + Add Exam
      </Button>
      {form.exams.map((exam, i) => (
        <SimpleGrid columns={2} key={i} spacing={2}>
          <Input
            placeholder="Exam Name"
            onChange={(e) => {
              const exams = [...form.exams];
              exams[i].examName = e.target.value;
              setForm({ ...form, exams });
            }}
          />
          <Input
            placeholder="Exam Name Hindi"
            onChange={(e) => {
              const exams = [...form.exams];
              exams[i].examNameHin = e.target.value;
              setForm({ ...form, exams });
            }}
          />
        </SimpleGrid>
      ))}

<Heading size="md" mt={6}>
  Subjects
</Heading>

<Stack direction="row" mt={2}>
  <Input
    placeholder="Subject Name"
    value={subjectInput}
    onChange={(e) => setSubjectInput(e.target.value)}
  />

  <Button onClick={addSubject}>
    Add Subject
  </Button>
</Stack>

<Stack mt={3}>
  {form.subject.map((sub, index) => (
    <Box
      key={index}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      borderWidth="1px"
      p={2}
      rounded="md"
    >
      <span>{sub}</span>

      <Button
        size="xs"
        colorScheme="red"
        onClick={() => removeSubject(index)}
      >
        Remove
      </Button>
    </Box>
  ))}
</Stack>
      {/* Sub Courses (From InActive Courses) */}
      <Heading size="md" mt={6}>
        Select Sub Courses
      </Heading>

      <Stack spacing={2} mt={2}>
        {inactiveCourses.map((course) => (
          <Checkbox
            key={course._id}
            isChecked={selectedSubCourses.includes(course._id)}
            onChange={() => handleSubCourseSelect(course._id)}
          >
            {course.planName} (₹{course.price})
          </Checkbox>
        ))}
      </Stack>

      <Button mt={6} colorScheme="blue" onClick={handleSubmit}>
        Create Plan
      </Button>

      {/* LIST */}
      {/* <Heading mt={10}>All Plans</Heading>
      <Stack mt={4}>
        {courses?.map((c) => (
          <Box key={c._id} borderWidth={1} p={4} rounded="md">
            <Heading size="md">{c.planName}</Heading>
            {c.planImage && <Image src={c.planImage} h="100px" />}
            <p>₹{c.price}</p>
            <p>{c.targetAudience}</p>
          </Box>
        ))}
      </Stack> */}
    </Box>
  );
};

export default CreateCourse;
